var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33329 2.41699C5.06561 2.41699 2.41663 5.06597 2.41663 8.33366C2.41663 11.6013 5.06561 14.2503 8.33329 14.2503C11.601 14.2503 14.25 11.6013 14.25 8.33366C14.25 5.06597 11.601 2.41699 8.33329 2.41699ZM0.916626 8.33366C0.916626 4.23755 4.23718 0.916992 8.33329 0.916992C12.4294 0.916992 15.75 4.23755 15.75 8.33366C15.75 12.4298 12.4294 15.7503 8.33329 15.7503C4.23718 15.7503 0.916626 12.4298 0.916626 8.33366Z",
    fill: "#BDBEBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8029 12.8037C13.0958 12.5108 13.5707 12.5108 13.8636 12.8037L18.8636 17.8037C19.1565 18.0965 19.1565 18.5714 18.8636 18.8643C18.5707 19.1572 18.0958 19.1572 17.8029 18.8643L12.8029 13.8643C12.51 13.5714 12.51 13.0965 12.8029 12.8037Z",
    fill: "#BDBEBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0b4a564993d9ac27fb17ca2917e14a5a.svg";
export { ForwardRef as ReactComponent };